import { render, staticRenderFns } from "./pie_chart.vue?vue&type=template&id=0a96f76e&scoped=true&lang=pug&"
import script from "./pie_chart.vue?vue&type=script&lang=coffee&"
export * from "./pie_chart.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96f76e",
  null
  
)

export default component.exports